module.exports = __webpack_public_path__ + "img/svgArrow21.bf2a0e4b.svg";